<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col class="py-0" cols="12" md="12">
              <el-text-field
                label="Įgaliojimo pasibaigimo ir pakeitimo pagrindas (LT)"
                v-model="formData.title_lt"
                :disabled="modeReadonly"
                :maxlength="200"
                required
              />
            </v-col>
            <v-col class="py-0" cols="12" md="12">
              <el-text-field
                label="Įgaliojimo pasibaigimo ir pakeitimo pagrindas (EN)"
                v-model="formData.title_en"
                :disabled="modeReadonly"
                :maxlength="200"
                required
              />
            </v-col>
            <v-col class="py-0" cols="12" md="12">
              <el-textarea
                autocomplete="off"
                name="Aprašymas"
                label="Aprašymas"
                type="text"
                :disabled="modeReadonly"
                :maxlength="200"
                v-model="formData.description"
              />
            </v-col>
            <v-col class="py-0" cols="12" md="6" lg="3">
              <el-text-field
                label="Kodas"
                disabled
                v-model="code"
                :maxlength="20"
              />
            </v-col>
            <v-col class="py-0" cols="12" md="6" lg="3">
              <el-autocomplete
                :items="enumsClassifiers.rejectReasonType"
                :disabled="getId"
                enums
                multiple
                itemvalue="value"
                itemtext="text"
                label="Požymis"
                v-model="formData.type"
              />
            </v-col>
            <v-col class="py-0" cols="12" md="6" lg="3">
              <el-date-picker
                label="Galioja nuo"
                required
                :disabled="modeReadonly"
                v-model="formData.valid_from"
              />
            </v-col>
            <v-col class="py-0" cols="12" md="6" lg="3">
              <el-date-picker
                label="Galioja iki"
                :afterDate="formData.valid_from"
                :disabled="modeReadonly"
                v-model="formData.valid_to"
              />
            </v-col>
            <v-col class="pt-0" cols="12" md="12">
              <el-checkbox
                :disabled="getId"
                :required="basisCheck"
                class="my-0"
                label="Pakeitimo pagrindas"
                v-model="formData.change_basis"
                validateKey="change_basis"
              >
              </el-checkbox>
            </v-col>
            <v-col class="pt-0" cols="12" md="12">
              <el-checkbox
                :disabled="getId"
                :required="basisCheck"
                class="my-0"
                label="Pasibaigimo pagrindas"
                v-model="formData.termination_basis"
                validateKey="termination_basis"
              >
              </el-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button
              v-if="!modeReadonly"
              title="Išsaugoti"
              :loading="loading"
              @click.native="saveData()"
              color="primary"
              icon="išsaugoti"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import Enums from '@/enums'

export default {
  name: 'AdminMandateTerminationForm',

  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      formData: {
        change_basis: false,
        termination_basis: false
      },
      code: null,
      enumsClassifiers: [],
    }
  },
  computed: {
    basisCheck() {
      if(this.formData.change_basis || this.formData.termination_basis){
        return false
      }
      return true
    },
    modeReadonly() {
      return false
    },
    getId() {
      return this.$route.params.id || null
    },
    getTitle() {
      if (this.getId) {
        return this.$t(`Redaguoti pasibaigimo / pakeitimo pagrindą`)
      } else {
        return this.$t(`Naujas pasibaigimo / pakeitimo pagrindas`)
      }
    },
  },
  beforeDestroy() {},
  created() {
    if (this.getId) {
      this.getData()
    }
    this.enumsClassifiers = Enums
  },
  methods: {
    back() {
      this.$router.push({ name: 'classifierMandateTermination' })
    },
    getData() {
      this.pageloading = true

      this.$axios
        .get(`expiration-reasons/${this.getId}`)
        .then((res) => {
          this.formData = res.data.expirationReason
          this.code = this.formData.code
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    saveData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = this.formData
          formData.basis = []
          if (formData.change_basis) {
            formData.basis.push('change');
          }
          if (formData.termination_basis) {
            formData.basis.push('end');
          }
          let url = `expiration-reasons`
          this.getId && (formData.id = this.getId)
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_CODE', '000110')
              this.back()
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
